export const jiraCommentsFormatter = request => {
  const { comments } = request
  if (comments && comments.length > 0) {
    //So this function does two things. Firstly, the .map strips out the member uuid from the Jira comment body and adds it to the comment object.
    //Secondly, the .sort sorts the comments by the date they were originally created.
    //For examples, check the sample.js for a full before and after, and index.test.js for more targeted changes in this directory
    const sortedComments = [...comments]
      .map(comment => {
        //This formatting is strange, and effectively just references the first bit of a text in a Jira comment. Normally you couldn't
        //guarantee that the first bit of content would be text, but since we're prefixing the whole message we actually can guarantee it.
        const firstText = comment.body?.content?.[0]?.content?.[0]?.text || ''
        //The '|-' and '-|: ' are just delimiters that we're using to separate the member uuid from the rest of the comment.
        //As an example, all together the prefix we're attaching would look something like this '|-mem_Mq73hGTa7sR8OuGUHV2l1wI8TaRdQz-|: '
        if (
          firstText &&
          firstText.indexOf('|-') === 0 &&
          firstText.includes('-|: ')
        ) {
          const updatedComment = { ...comment }
          //This line splits out our prefix from any additional message content
          let splitText = firstText.split('-|: ')
          //Then this splits out the member uuid from the prefix, so that the member uuid alone is added to the comment object
          updatedComment.memberUuid = splitText[0].split('|-')[1]
          //The following conditional is to handle the case where the comment is only the member uuid (typically for file uploads with no text comment)
          if (splitText[1]) {
            updatedComment.body.content[0].content[0].text = splitText[1]
          } else if (updatedComment.body.content[0].content.length > 1) {
            updatedComment.body.content[0].content.shift()
          } else {
            updatedComment.body.content.shift()
          }
          return updatedComment
        }
        return comment
      })
      .sort((comment1, comment2) => {
        return new Date(comment2.created) - new Date(comment1.created)
      })
    let mostRecentComment = ''
    sortedComments[0].body.content.forEach(content => {
      content.content?.forEach(c => {
        if (c.text) {
          mostRecentComment += c.text.trim() + ' '
        }
      })
    })

    const updatedRequest = {
      ...request,
      comments: sortedComments,
      mostRecentComment:
        mostRecentComment.length > 100
          ? mostRecentComment.trim().substring(0, 100) + '...'
          : mostRecentComment.trim(),
    }
    return updatedRequest
  }
  return request
}
